// ── 계약완료 목록 행 상태 (배경색·필터의 단일 진실) ───────────────────────────
//   ContractRow(색) 과 ContractManagement(색상 필터) 가 같은 함수를 써 절대 어긋나지 않게 한다.

/**
 * 행 상태 — pageStyles.js `resolveRowColors` 와 우선순위 동일해야 한다.
 * 우선순위: 취소 > 미계약 > 배송완료 > 계약완료.
 * @returns {'cancelled'|'not_contracted'|'shipped'|'contracted'}
 */
export function resolveRowState(row) {
  if (row.contract_status === 'cancelled') return 'cancelled';
  if (!row.is_contracted) return 'not_contracted';
  const deliveryItems = Array.isArray(row.delivery_items) ? row.delivery_items : [];
  // 직접수령 줄도 배송 끝남(2026-10-30 사용자 확정 1-a)
  const hasShipped = deliveryItems.some((i) => (i.courier && i.tracking_number) || i.is_pickup)
    || (row.courier && row.tracking_number);
  return hasShipped ? 'shipped' : 'contracted';
}

/**
 * 계약완료 목록 배경색 필터 버튼 정의 (회색=미계약은 제외 — 사용자 확정).
 * swatch = 행 배경과 같은 색(흰=계약완료, 초록=배송완료, 빨강=계약취소).
 */
export const CONTRACT_COLOR_FILTERS = [
  { key: 'contracted', title: '계약완료', swatch: 'var(--bg-card)', accent: '#94a3b8', light: true },
  { key: 'shipped',    title: '배송완료', swatch: '#16a34a',        accent: '#16a34a' },
  { key: 'cancelled',  title: '계약취소', swatch: '#f43f5e',        accent: '#f43f5e' },
];
